import React, { useState, useEffect, useContext } from 'react';
import hamburgerLogo from '../../../images/icons/hum.svg';
import customerService from '../../../images/icons/customer-service.svg';
import notification from '../../../images/icons/Group.svg';
import profileAv from '../../../images/icons/profileAv2x.png';
import chevron from '../../../images/icons/chevron.svg';
import { getUserNumber } from '../../utils/cookie-utils';
import ProfileModal from '../ProfileModal/ProfileModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/pro-solid-svg-icons';
import WhatsAppNotification from '../WhatsAppNotification/WhatsAppNotification';
import Badge from '@material-ui/core/Badge';
import { getNotificationCount } from '../../../common/constants/api';
import NotificationDataContext from '../../../../../lems-ui/src/common/Context/NotificationDataContext';

export default function Header() {
  const [countData, setCountData] = useState(0);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem('userData')) || ''
  );
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState(false);
  const messages = useContext(NotificationDataContext);

  const openNav = () => {
    const x = document.getElementById('sideBar');
    x.style.display = 'block';
    x.style.opacity = 1;
    x.style.width = '100%';
  };
  useEffect(() => {
    getNotificationCount()
      .then(res => {
        if (res == 0) return;
        setCountData(`${res}`);
      })
      .catch(error => {});
  }, []);
  useEffect(() => {
    setCountData(messages?.count_notification?.count || 0);
  }, [messages?.count_notification?.count]);

  return (
    <>
      <div className="  md:flex md:flex-row justify-between md:justify-end w-full bg-transparent h-20 hidden md:widhtMd  ">
        {/* mobile icons */}
        <WhatsAppNotification
          notification={notification}
          setNotification={setNotification}
        />
        <div>
          <div className=" block md:hidden h-12 w-12 ml-3 mt-4">
            <img
              className="block object-cover cursor-pointer"
              onClick={() => openNav()}
              src={hamburgerLogo}
              alt="menu"
            />
          </div>
        </div>
        <div className="inline-flex md:hidden items-center justify-center">
          <div className=" block md:hidden h-12 w-12 ml-3 mt-4">
            <img
              className="block object-cover"
              src={customerService}
              alt="menu"
            />
          </div>
          <div className=" block md:hidden h-12 w-12 ml-3 mt-4">
            <img className="block object-cover" src={notification} alt="menu" />
          </div>
        </div>

        <div className="dropdown hidden md:inline-flex flex-shrink-0 items-center justify-around md:justify-around w-auto profileImg mr-3">
          <div>
            <Badge
              badgeContent={countData}
              color="error"
              style={{ marginRight: '28px' }}
              max={999}
            >
              <FontAwesomeIcon
                icon={faBell}
                size="2x"
                style={{
                  color: 'gray',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setNotification(!notification);
                }}
              />
            </Badge>
          </div>
          <div className="">
            <img
              className="w-10 h-10 rounded-full"
              src={profileAv}
              alt="logo"
            />
          </div>
          <div className="hidden md:block">
            <p className="text-lg ml-3">
              {userDetails
                ? `${userDetails.name.firstName.substring(0, 20)}`
                : `${getUserNumber().substring(0, 20)}`}
            </p>
          </div>
          <div className="ml-3 flex flex-col cursor-pointer">
            <div
              onClick={() => {
                setShow(!show);
              }}
            >
              <img
                className={show ? 'block transform rotate-180' : ''}
                src={chevron}
                alt="v"
              />
            </div>
            <ProfileModal show={show} setShow={setShow} />
          </div>
        </div>
      </div>
    </>
  );
}
